export const CONFIRMATION_EMAIL_PENDING =
  "A confirmation email will be sent and My trips will be updated within 1-2 hours.";

// This is the backend error from Tysons when a timeout occurs and the cancellation is sent to an agent to confirm
export const CANCELLATION_FAILURE_COMMIT_ERROR =
  "CancellationFailure - Call to commit flight cancel failed";

export const cancelTitles = Object.freeze({
  AIRLINE_MANAGED: "Please contact airline",
  CANCEL_FAILED: "Cancellation failed",
  CANCEL_INFO: "Cancellation information",
  CANCEL_REQUESTED: "Cancellation requested",
  CANT_SELF_SERVICE:
    "Unfortunately, this type of fare cannot be cancelled via self-service. To cancel, please contact support",
  CONTACT_CUSTOMER_SUPPORT: "Please contact customer support",
  CONFIRMATION: "Confirm cancellation",
  DEPARTED_TITLE: "This flight has departed",
  DEPARTED_SUBTITLE: "Please contact the airline for further assistance.",
  GET_INFO_ERROR: "Error while loading flight's cancellation info",
  LOADING: "Loading flight details and cancellation policy...",
  LOAD_FAILED: "We couldn't load your flight cancel information",
  PROCESSING: "Your cancellation is being processed...",
  PENDING_CANCELLATION: "We're processing your confirmation",
  BOOKING_ALREADY_CANCELLED: `Your booking has already been cancelled. ${CONFIRMATION_EMAIL_PENDING}`,
  BOOKING_CANCEL_PENDING: `Your booking has been cancelled. ${CONFIRMATION_EMAIL_PENDING}`,
  PROCESSING_SUBTITLE: "Please do not exit until the cancellation is complete.",
  SABRE_CONTACT_AIRLINE:
    "To cancel and claim your refund, you must contact the airline.",
  TRVK_OUTAGE_SUBTITLE:
    "We're experiencing technical difficulties, if your request is urgent please contact support at 844-422-6922.",
  TRVK_OUTAGE_TITLE: "Please try again in a few minutes",
  TRY_AGAIN: "Please try again or contact support",
  COMPLETE_CANCELLATION_FLIGHT:
    "Complete the cancellation of your flight for all travelers.",
});

export const TF = "travelfusion";
export const TF_PREFIX = "Z-";
export const SABRE = "sabre";
export const AMADEUS = "amadeus";
export const AMADEUS_PREFIX = "M-";

export const buttonText = {
  CANCEL: "Cancel flight",
  REFRESH_POLICY: "Refresh policy",
  CANCEL_ALL: "Cancel all flights",
  CLOSE: "Close",
  CONFIRM_CANCEL: "Confirm cancellation",
  CONTACT_AIRLINE: "Continue to the airline's website",
  CONTACT_SUPPORT: "Contact support",
  DONE: "Done",
  GET_INFO: "Get cancellation info",
  TRY_AGAIN: "Try again",
};
